var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flex',{staticClass:"login-page"},[_c('div',[_c('Spacer',{staticClass:"typo--2 t-center",attrs:{"x":"m","top":{
        default: 'l',
        s: 'xl'
      },"bottom":"m"}},[_vm._v(" "+_vm._s(_vm.$labels.create_account)+" ")]),_c('Wrapper',{attrs:{"size":"m","boxed":""}},[_c('Form',{staticClass:"form--single form-theme--default",attrs:{"id":"register","theme":"single"}})],1)],1),_c('div',{staticClass:"login-background",style:(_vm.backgroundImage)})])}
var staticRenderFns = []

export { render, staticRenderFns }